import React, { useEffect, useState, useContext,useCallback,useRef } from 'react';
import axios from "axios";

import { useNavigate,useLocation,useParams,useSearchParams } from 'react-router-dom';
import { useSport } from '../../utils/SportsProvider'

import { AuthContext } from '../login/AuthContext';
import FullCardGrid from '../GridViewMain/FullCardGrid/FullCardGrid';
import HorizontalGrid from './HorizontalGrid';
import ViewSaleOffer from './ViewSaleTradeOffer/ViewSaleOffer';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';

import ViewTradeOffer from './ViewSaleTradeOffer/ViewTradeOffer';

import { toast } from 'react-toastify';
import RadioButtonSlider from '../UsefulComponent/RadioButtonSlider'

 import {useTour} from '../../OnBoardingTour/TourProvider'
 import SeoHelmet from '../../Seo/SeoHelmet';
 import BannerAddCard from '../GridViewMain/FullCardGrid/AddCardBanner/BannerAddCard';
const GridViewSell = () => {

  const navigate = useNavigate();
  const { view: viewParam } = useParams();      // "grid" | "offers" | "review" | undefined
  const [searchParams, setSearchParams] = useSearchParams();

  const { state } = useSport();        // state.sport = "Hockey" | "Pokemon"
const sport = state.sport;

   // map path segment <-> internal view keys
const PATH_TO_VIEW = {
  grid: "cardGrid",
  offers: "soldOrOffer",
  review: "finishYourListings",
};
const VIEW_TO_PATH = {
  cardGrid: "grid",
  soldOrOffer: "offers",
  finishYourListings: "review",
};


function hydrateCardForUI(row) {
  const isPokemon = row?.CatalogType === 'Pokemon';

  // images
  const imageFront = row.ImageFront || row.Image || null;
  const imageBack  = row.ImageUserBack || row.ImageBack || null;

  // unified name/set/number
  const Name        = row.Name || row.CardName || row.cardName || ''; // hockey uses Name, pokemon uses CardName
  const SetName     = row.SetName || row.setName || row.SeriesName || ''; // pokemon has setName + SeriesName
  const NumberBehind= row.NumberBehind || row.NumberInSet || row.Number || '';

  // CASE-style flags already provided by your SQL:
  // isForSale, isForTrade, isPC, isOnEbay, isGone, Graded, IsRookie, IsPatch, IsJersey, IsAuto
  // For Pokémon they exist but are neutral when not applicable.

  // grading / condition fallbacks
  const GradeCompany = row.GradeCompany || '';
  const Grade        = Number(row.Grade || 0);
  const ConditionCard= row.ConditionCard || 'NM';

  // seller profile metrics (might be undefined on some rows)
  const NumberOfTransactions = Number(row.NumberOfTransactions || 0);
  const AverageRating        = Number(row.AverageRating || 0); // 0..5 (you multiply by 20 later)

  // card/variation display (what your grid shows in the “variation line”)
  const cardName      = row.cardName || row.CardName || Name || '';
  const variationName = row.variationName
                     || row.VariationName
                     || (isPokemon ? (row.RarityName || '') : (row.Variation || '')); // Pokémon: show rarity as a variation-like tag

  // number out of (sports sometimes have Numbered, Pokémon usually doesn’t)
  const Numbered = row.Numbered || null;

  // price/TV
  const Price        = row.Price ?? null;
  const EstimateValue= Number(row.EstimateValue || 0);

  // ids used by your grid
  const id         = row.id;               // usercards.id (your grid uses this)
  const userCardId = row.userCardId || row.id;

  return {
    ...row,
    // unified props your grid already reads:
    ImageFront: imageFront,
    ImageBack:  imageBack,
    Name,
    SetName,
    NumberBehind,
    GradeCompany,
    Grade,
    ConditionCard,
    NumberOfTransactions,
    AverageRating,
    cardName,
    variationName,
    Numbered,
    Price,
    EstimateValue,
    id,
    userCardId,
  };
}


//  // read primary view from path, fallback to legacy ?sellView=
//   const sellView =
//     PATH_TO_VIEW[viewParam] ??
//     (searchParams.get("sellView") || "cardGrid");

//   // read optional params from query
//   const preselected = searchParams.get("preselected") || null; // "ShipNow" etc.
//   const asWho = searchParams.get("asWho") || null;   
//    const transactionId = searchParams.get("transactionId") || null; 
//   const layoutParam = searchParams.get("layout") || "grid";    // optional if you use it


  const updateParams = useCallback((patch, replace = true) => {
    const sp = new URLSearchParams(searchParams);
    Object.entries(patch).forEach(([k, v]) => {
      if (v == null || v === "") sp.delete(k);
      else sp.set(k, String(v));
    });
    setSearchParams(sp, { replace });
  }, [searchParams, setSearchParams]);

//   const setSellView = useCallback((next) => {
//     const path = `/marketplace/${VIEW_TO_PATH[next]}`;
//     navigate(`${path}?${searchParams.toString()}`, { replace: false });
//   }, [navigate, searchParams]);


//  // ---------------- your existing state ----------------
//   // UI state driven by URL
//   const [seeFinishYourListings, setSeeFinishYourListings] = useState(false);
//   const [seeSoldOrOffer, setSeeSoldOrOffer] = useState(false);
//   const [seeCardGrid, setSeeCardGrid] = useState(true);
//   const [preselectedOption, setPreselectedOption] = useState(preselected);
//   const [asWhoState, setAsWhoState] = useState(asWho);
//   const [preSelectedTransaction,setPreselectedTransaction] = useState(transactionId)
//   const [viewAsGrid, setViewAsGrid] = useState(layoutParam === "group");


  
//   useEffect(() => {
//     setSeeSoldOrOffer(sellView === "soldOrOffer");
//     setSeeFinishYourListings(sellView === "finishYourListings");
//     setSeeCardGrid(sellView === "cardGrid");
//     setPreselectedOption(preselected);
//     setPreselectedTransaction(transactionId)
//     setAsWhoState(asWho);
//     setViewAsGrid(layoutParam === "group");
//   }, [sellView, preselected, asWho, layoutParam,preSelectedTransaction]);

//   // use these instead of your old EnableView()
//   const goGrid   = () => setSellView("cardGrid");
//   const goOffers = () => setSellView("soldOrOffer");
//   const goReview = () => setSellView("finishYourListings");

//   // example: toggle grid/group layout and persist to URL

//   const toggleViewAsGrid = () => {
//     const next = !viewAsGrid;
//     setViewAsGrid(next);
//     updateParams({ layout: next ? "grid" : "group" });
//   };

// Derived from path/query (single source of truth)
const sellView =
  PATH_TO_VIEW[viewParam] ?? (searchParams.get("sellView") || "cardGrid");

const preselected = searchParams.get("preselected");
const asWho       = searchParams.get("asWho");
const transactionId = searchParams.get("transactionId");
const layoutParam = searchParams.get("layout") || "grid";

// Derived booleans, no local state needed
const isCardGrid  = sellView === "cardGrid";
const isOffers    = sellView === "soldOrOffer";
const isReview    = sellView === "finishYourListings";

// If you want a boolean for layout:
//const viewAsGrid = layoutParam !== "group"; 
// true means "grid" visually
const viewAsGrid = false
// Navigation helpers stay the same
const setSellView = useCallback((next) => {
  const path = `/marketplace/${VIEW_TO_PATH[next]}`;
  navigate(`${path}?${searchParams.toString()}`, { replace: false });
}, [navigate, searchParams]);

const goGrid   = () => setSellView("cardGrid");
const goOffers = () => setSellView("soldOrOffer");
const goReview = () => setSellView("finishYourListings");

const toggleViewAsGrid = () => {
  const next = !viewAsGrid;
  updateParams({ layout: next ? "grid" : "group" }); // no local state
};


   // Update preselected option whenever state changes
 
  

  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.GridViewMain[key][currentLang]; // Adjust the path according to your JSON structure
 
  const {userId,liveCsrfToken,loading, isAuthenticated,jwtToken } = useContext(AuthContext);
  const [sellingCards, setSellingCards] = useState([]);
  
  const [groupedCards, setGroupedCards] = useState([]);

  const [completeListings,setCompleteListings]= useState([])
 
  const [soldOrOffer,setSoldOrOffer]=useState([])
   const [seeTradeOffer, setSeeTradeOffer] = useState(false);
     const [tradeOffers, setTradeOffers] = useState([]);

     //const [preselectedState, setPreselectedState] = useState(preselected || null);


    const [fullCountTradeSale,setFullCountTradeSale] = useState(soldOrOffer.length+tradeOffers.length)
  // Import the getItem function from the utils_localStorage module


// useEffect(() => {
//   setTimeout(() => {
//     startTour('marketplace');
//   }, 500); // ⏱ small delay so DOM loads first
// }, []);

  // useEffect(() => {
  //   // Set views based on query params
  //   if (sellView === 'soldOrOffer') {
  //     setSeeSoldOrOffer(true);
  //     setSeeCardGrid(false);
  //     setSeeFinishYourListings(false);
  //   } else if (sellView === 'finishYourListings') {
  //     setSeeFinishYourListings(true);
  //     setSeeSoldOrOffer(false);
  //     setSeeCardGrid(false);
  //   } else {
  //     setSeeCardGrid(true);  // Default to card grid
  //     setSeeSoldOrOffer(false);
  //     setSeeFinishYourListings(false);
  //   }
  
  //   setPreselectedOption(preselected || null);
  //   setAsWhoState(asWho || null);
  // }, [sellView, preselected, asWho]);



// const EnableView = (view) => {
//   updateParams({ sellView: view }); // keeps current /fr/ path intact
// };
  const fetchCardsData = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/marketplace/getSellingCards?sport=${encodeURIComponent(sport)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    });
      const json = await res.json();
      console.log('json123123',json)
       const hydrated = Array.isArray(json) ? json.map(hydrateCardForUI) : [];
      setSellingCards(hydrated); // Update the userCards state with fresh data
      
    } catch (error) {
      console.log('Error fetching card data:', error);
    }
  };
  
  const fetchToCompleteListing = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/marketplace/getCompleteListings/${userId}?sport=${encodeURIComponent(sport)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
            headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
          "Authorization": `Bearer ${jwtToken}`
        },
    }); 
      const json = await res.json();
      const hydrated = Array.isArray(json) ? json.map(hydrateCardForUI) : [];
      setCompleteListings(hydrated); // Update the userCards state with fresh data
      console.log('Complete Listings:', hydrated);
      console.log('Complete Listings json:', json);
    } catch (error) {
      console.log('Error fetching card data:', error);
    }
  };
  
  const fetchSoldOrOffer = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/getSoldOrOffer/${userId}?sport=${encodeURIComponent(sport)}`,
        {
          
          withCredentials: true,
          headers: { "x-csrf-token": liveCsrfToken },
        }
      );
  
      if (response.status === 200) {
        const json = response.data;
        console.log("Fetched Sold or Offer data:", json);
  
        if (JSON.stringify(soldOrOffer) !== JSON.stringify(json)) {
             const hydrated = Array.isArray(json) ? json.map(hydrateCardForUI) : [];
          setSoldOrOffer(hydrated); // ✅ Update state only if data changed
          console.log('soldOrOffer',json)
        } else {
          console.log("No new updates in sold or offer data.");
        }
      } else {
        console.error("Failed to fetch sold or offer data:", response.data.error);
      }
    } catch (error) {
      console.error("Error fetching card data:", error.message || error);
    }
  };
// ✅ GET + axios semantics + same shape as your sold listing call
const fetchTradeOffers = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradeOffer/${userId}?sport=${encodeURIComponent(sport)}`,
      {
        withCredentials: true,
              headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken,
          "Authorization": `Bearer ${jwtToken}`
        },
        
      }
    );

    if (response.status === 200) {
      const json = response.data;
      // optional: avoid redundant updates
      if (JSON.stringify(tradeOffers) !== JSON.stringify(json)) {
          const hydrated = Array.isArray(json) ? json.map(hydrateCardForUI) : [];
        setTradeOffers(hydrated);
      }
    } else {
      console.error("Failed to fetch trade offer data:", response.data?.error);
    }
  } catch (e) {
    console.error("Error fetching trade offer data:", e?.message || e);
    toast.error(t("Error fetching trade offer data"));
  }
};

  
const prepTradeData = async(rawData)=>{
console.log('rawData de get tradeOffer',rawData)
  return rawData
}

useEffect(() => {
  fetchCardsData();
  if (!userId) return;
 console.log("userId and liveCsrfToken available, fetching additional data...", { userId, liveCsrfToken });
  if(userId && liveCsrfToken)
  {
  fetchToCompleteListing();
  fetchSoldOrOffer();
   fetchTradeOffers();
  }
}, [userId,liveCsrfToken, loading, isAuthenticated,sport]);
useEffect(() => {
  console.log("Current userId in GridViewSell:", userId);
}, [userId]);

useEffect(() => {
  setFullCountTradeSale(soldOrOffer.length+tradeOffers.length)
}, [soldOrOffer,tradeOffers]);


  function NavigateToCreateCardForm() {
 
      const base = i18n.language === 'fr' ? '/fr/createCardForm' : '/createCardForm';
  const sp = new URLSearchParams(searchParams);
  sp.set('sport', sport);
  navigate(`${base}?${sp.toString()}`);
  }


  
  useEffect(() => {
    if (sellingCards.length > 0&&viewAsGrid) {
      const fetchedCards = sellingCards;
      console.log('fetchedCards',fetchedCards)
      const cardMap = fetchedCards.reduce((acc, card) => {
       
        const cardDetails = {
          // Ensure all properties are validated against being null or empty
          id: card.id || "",
          imageFront: card.ImageFront || "",
          imageUserBack: card.ImageUserBack || "",
          graded: card.Graded || "",
          gradeCompany: card.GradeCompany || "",
          grade: card.Grade || "",
          ConditionCard: card.ConditionCard || "",
          EstimateValue: parseFloat(card.EstimateValue) || "",
          Price:parseFloat(card.Price)||"",
          PaidPrice:parseInt(card.UserId)===parseInt(userId)?card.PaidPrice:0,
          isForSale: card.isForSale || "",
          isForTrade: card.isForTrade || "",
          isOnEbay: card.isOnEbay || "",
          InsertDate:parseInt(card.UserId)===parseInt(userId)?card.InsertDate:null,
          UserId: card.UserId || "",
          ShowName: card.ShowName || "",
          Rating: parseFloat(card.Rating) || 4,
          Country: card.Country || "",
          Shipping:card.Shipping ||0,
          totalSales:24,
          ProfilPicture:card.ProfilPicture||"",
        };
  
        if (!acc.has(card.CardId)) {
          // Initialize with the current card's details and set the lowestEstimateValue to the current card's EstimateValue
          acc.set(card.CardId, {
            ...card,
            sameCardCount: 1,
            grades: {
              Raw: { 
                count: card.Graded && card.Graded.toLowerCase() === "raw" ? 1 : 0, 
                lowestEstimateValue: card.Graded && card.Graded.toLowerCase() === "raw" ? card.EstimateValue : Infinity 
              },
              Graded: { 
                count: card.Graded && card.Graded.toLowerCase() !== "raw" ? 1 : 0, 
                lowestEstimateValue: card.Graded && card.Graded.toLowerCase() !== "raw" ? card.EstimateValue : Infinity 
              },
            },
            blend: [cardDetails], // Initialize blend as an array with the current card's details
          });
        } else {
          const entry = acc.get(card.CardId);
          entry.sameCardCount += 1;
          entry.blend.push(cardDetails); // Append the current card's details to the blend array
  
          // Update grades logic and lowestEstimateValue
          if (card.Graded && card.Graded.toLowerCase() === "raw") {
            entry.grades.Raw.count += 1;
            entry.grades.Raw.lowestEstimateValue = Math.min(entry.grades.Raw.lowestEstimateValue, card.EstimateValue);
          } else if (card.Graded && card.Graded.toLowerCase() !== "raw") {
            entry.grades.Graded.count += 1;
            entry.grades.Graded.lowestEstimateValue = Math.min(entry.grades.Graded.lowestEstimateValue, card.EstimateValue);
          }
  
          acc.set(card.CardId, entry);
        }
  
        return acc;
      }, new Map());
  
      setGroupedCards(cardMap);
      console.log('cardMap',cardMap)
    }
  }, [sellingCards,viewAsGrid]);





  // const EnableView = (view) => {
  //   switch (view) {
  //     case 'finishYourListings':
  //       setSeeFinishYourListings(true);
  //       setSeeSoldOrOffer(false);
  //       setSeeCardGrid(false);
  //       navigate(i18n.language === 'fr' ? `/fr/marketplace?sellView=finishYourListings`:`/marketplace?sellView=finishYourListings`)
            
  //       break;
  //     case 'soldOrOffer':
  //       setSeeFinishYourListings(false);
  //       setSeeSoldOrOffer(true);
  //       setSeeCardGrid(false);
       
  //       navigate(i18n.language === 'fr' ? `/fr/marketplace?sellView=soldOrOffer`:`/marketplace?sellView=soldOrOffer`)
  //       break;
  //     case 'cardGrid':
  //       setSeeFinishYourListings(false);
  //       setSeeSoldOrOffer(false);
  //       setSeeCardGrid(true);
     
  //        navigate(i18n.language === 'fr' ? `/fr/marketplace?sellView=cardGrid`:`/marketplace?sellView=cardGrid`)
  //       break;
  //   }
  // };
  
 
 const OffersDashboard = ({ saleOffers, tradeOffers, userId, preselected,preSelectedTransaction, asWho, liveCsrfToken, fetchSoldOrOffer, t }) => {
  const [viewMode, setViewMode] = useState(asWho === "Trader" ? "Trades🔁" : "Buy/Sell");

  function setViewModeFunc(newViewMode) {
    setViewMode(newViewMode);
    const asWhoNext = newViewMode === "Buy/Sell" ? "Buyer" : "Trader";   // FIXED
    updateParams({ asWho: asWhoNext });                                     // FIXED
  }

  return (
    <>
      {/* <h2 style={{ gridColumn: '1/ span 12' }}>
        {viewMode == "Buy/Sell" ? t("View Sale Offers") : t("View Trade Offers")}
      </h2> */}

      <div style={{ marginBottom: '10px' }} className='MobileSlider'>
        <RadioButtonSlider
          activeType={viewMode}
          setActiveType={setViewModeFunc}
          leftLabel={"Buy/Sell"}
          rightLabel={"Trades🔁"}
          t={t}
        />
      </div>

      {viewMode === "Buy/Sell" && saleOffers.length > 0 && (
        <ViewSaleOffer
          saleOffers={saleOffers}
          userId={parseInt(userId)}
          preselected={preselected}
          preSelectedTransaction={preSelectedTransaction}
          asWho={asWho}
          liveCsrfToken={liveCsrfToken}
          fetchSoldOrOffer={fetchSoldOrOffer}
        />
      )}

      {viewMode === "Trades🔁" && tradeOffers.length > 0 && (
        <ViewTradeOffer
          tradeOffers={tradeOffers}
          userId={parseInt(userId)}
          liveCsrfToken={liveCsrfToken}
          fetchTradeOffers={fetchTradeOffers}
          preSelectedTransaction={preSelectedTransaction}
        />
      )}
    </>
  );
};

  

// function TitleWithMenu({ t, activeView, goGrid, goReview, goOffers, counts }) {
//   const [open, setOpen] = useState(false);
//   const ref = useRef(null);

//   // close on click-outside / Esc
//   useEffect(() => {
//     const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     const onEsc = (e) => { if (e.key === "Escape") setOpen(false); };
//     document.addEventListener("mousedown", onDocClick);
//     document.addEventListener("keydown", onEsc);
//     return () => {
//       document.removeEventListener("mousedown", onDocClick);
//       document.removeEventListener("keydown", onEsc);
//     };
//   }, []);

//   // Titles per view
//   const VIEW_TITLE = {
//     cardGrid: t("MarketPlace"),
//     finishYourListings: t("Review your listings"),
//     soldOrOffer: t("Offer & Sale Manager"),
//   };
//   const title = VIEW_TITLE[activeView] ?? t("MarketPlace");

//   // Menu config (includes MarketPlace)
//   const ITEMS = [
//     { key: "cardGrid",          label: t("MarketPlace"),            count: counts?.market ?? 0,  onClick: goGrid },
//     { key: "finishYourListings",label: t("Review your listings"),   count: counts?.listings ?? 0, onClick: goReview },
//     { key: "soldOrOffer",       label: t("Offer & Sale Manager"),   count: counts?.offers ?? 0,   onClick: goOffers },
//   ];

//   return (
//     <div className="marketplace-titlebar" style={{ gridColumn: "1 / span 4" }} ref={ref}>
//       <h1>{title}</h1>

//       <button
//         type="button"
//         className="title-menu__trigger"
//         aria-haspopup="menu"
//         aria-expanded={open}
//         onClick={() => setOpen(v => !v)}
//       >
//         {t("More")} <span className={`chev ${open ? "up" : ""}`} aria-hidden>▾</span>
//       </button>

//       {open && (
//         <div className="title-menu__list" role="menu">
//           {ITEMS.map(item => (
//             <button
//               key={item.key}
//               role="menuitem"
//               onClick={() => { setOpen(false); item.onClick(); }}
//               aria-current={activeView === item.key ? "page" : undefined}
//               className={activeView === item.key ? "is-active" : undefined}
//             >
//               {item.label} <span className="count">({item.count})</span>
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }


function TitleWithMenu({ t, activeView, goGrid, goReview, goOffers, counts }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const btnRef  = useRef(null);
  const popId   = "mp-title-menu";

  // Titles per view
  const VIEW_TITLE = {
    cardGrid: t("MarketPlace"),
    finishYourListings: t("Review your listings"),
    soldOrOffer: t("Offer & Sale Manager"),
  };
  const title = VIEW_TITLE[activeView] ?? t("MarketPlace");

  // Menu config (includes MarketPlace)
  const ITEMS = [
    { key: "cardGrid",            label: t("MarketPlace"),          count: counts?.market   ?? 0, onClick: goGrid   },
    { key: "finishYourListings",  label: t("Review your listings"), count: counts?.listings ?? 0, onClick: goReview },
    { key: "soldOrOffer",         label: t("Offer & Sale Manager"), count: counts?.offers   ?? 0, onClick: goOffers },
  ];

  // Close on outside click & Esc
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (!wrapRef.current?.contains(e.target)) setOpen(false);
    };
    const onEsc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("pointerdown", onDown, { passive:true });
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  // When opening, focus the first item for better mobile/KB behavior
  useEffect(() => {
    if (!open) return;
    const first = wrapRef.current?.querySelector(`#${popId} [role="menuitem"]`);
    (first)?.focus?.();
  }, [open]);

  return (
    <div className="marketplace-titlebar" style={{ gridColumn: "1 / span 4" }} ref={wrapRef}>
      <h1 className="mp-title">
        <button
          ref={btnRef}
          type="button"
          className={`mp-title__trigger ${open ? "is-open" : ""}`}
          aria-haspopup="menu"
          aria-expanded={open}
          aria-controls={popId}
          onClick={() => setOpen(v => !v)}
          onKeyDown={(e) => { if (e.key === "ArrowDown") setOpen(true); }}
        >
          <span className="mp-title__text">{title}</span>
          <span className="mp-title__caret" aria-hidden />
        </button>
      </h1>

      {open  && (
        <div id={popId} className="title-menu__list" role="menu">
          {ITEMS.map(item => (
            <button
              key={item.key}
              role="menuitem"
              className={`title-menu__item ${activeView === item.key ? "is-active" : ""}`}
              onClick={() => { setOpen(false); item.onClick(); }}
              disabled={!userId}
            >
              <span className="label">{item.label}</span>
              <span className="count">({item.count})</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}



  return (
    <section className='grid'>
      <SeoHelmet type="marketplace" />
      <div className="contentfront">
      
      {/* <button onClick={() => startTour('marketplace')}>Start Tour</button> */}
        <div className='justify top-page'>
          {/* <div> */}
          
       {/* <div className="market-button-grid">
        {parseInt(userId) > 0 && (
          <>
            <button onClick={goReview} className="btn-baseBlue Secondary">{t('Review your listings')} ({completeListings.length})</button>
            <button onClick={goOffers} className="btn-baseBlue Secondary">{t('Offer & Sale Manager')} ({fullCountTradeSale})</button>
          </>
        )}
        <button onClick={goGrid} className="btn-baseBlue wborder">
          {t("MarketPlace")} ({sellingCards.length})
        </button>
      </div> */}
 
    <BannerAddCard onAddCards={NavigateToCreateCardForm}/>

          </div>
         

  {/* <h1>{t('MarketPlace')}</h1> */}

<TitleWithMenu
  t={t}
  activeView={sellView}                     // <- from your PATH_TO_VIEW logic
  goGrid={goGrid}
  goReview={goReview}
  goOffers={goOffers}
  counts={{
    market: sellingCards.length,            // MarketPlace count
    listings: completeListings.length,      // Review your listings
    offers: fullCountTradeSale,             // Offer & Sale Manager
  }}
/>


{isReview && userId && liveCsrfToken && (
  <HorizontalGrid data={completeListings} userId={userId} liveCsrfToken={liveCsrfToken} />
)}

{isOffers && userId && liveCsrfToken && (
  soldOrOffer.length + tradeOffers.length > 0 ? (
    <OffersDashboard
      saleOffers={soldOrOffer}
      tradeOffers={tradeOffers}
      userId={userId}
      preselected={preselected}
      preSelectedTransaction={transactionId}
      asWho={asWho}
      liveCsrfToken={liveCsrfToken}
      fetchSoldOrOffer={fetchSoldOrOffer}
      t={t}
    />
  ) : (
    <div className="offers-emptyState">
      <div className="offers-emptyState__card">
      

        <div className="offers-emptyState__content">
          <h3>{t("No trade or sale offers to display.")}</h3>
          <p>{t("Once buyers or traders interact with your listings, their offers will appear here.")}</p>

          <button
            className="offers-emptyState__button btn-baseBlue"
            onClick={() =>
              navigate(i18n.language === "fr" ? "/fr/market-and-trades" : "/market-and-trades")
            }
          >
            {t("Browse Marketplace")}
          </button>
        </div>
      </div>
    </div>
  )
)}

{isCardGrid && (
  <FullCardGrid
    setCards={setSellingCards}
    cards={sellingCards}
    groupedCards={groupedCards}
    viewAsGrid={viewAsGrid}
    viewOnly={!userId}
    cardGridType="CardGridSell"
    toggleViewAsGrid={toggleViewAsGrid}
    sport={sport}
  />
)}

     
        </div>
      {/* </div> */}
    </section>
  );
  
}

export default GridViewSell;
